var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#51a548",
    d: "M11.643 4.538a.706.706 0 1 0-1.411 0v1.764h1.411zm0 4.234a.706.706 0 1 0-1.411 0 .706.706 0 0 0 1.411 0zm1.765-2.47c.39 0 .705.316.705.706v3.528c0 .39-.315.706-.705.706h-4.94a.706.706 0 0 1-.706-.706V7.008c0-.39.316-.706.706-.706h.705V4.538a1.764 1.764 0 0 1 3.529 0v1.764zm-6.352 4.234c.002.249.07.492.197.706H1.058a1.059 1.059 0 0 1-1.059-1.059v-.918a2.965 2.965 0 0 1 2.964-2.963h.368a3.84 3.84 0 0 0 3.216 0h.368c.11 0 .214.022.32.033a1.391 1.391 0 0 0-.179.673zm-4.94-7.763a2.823 2.823 0 1 1 5.646 0 2.823 2.823 0 0 1-5.646 0z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocked);
export default __webpack_public_path__ + "static/media/icon_locked.59fc5289.svg";
export { ForwardRef as ReactComponent };